export enum AwsCognitoKeyEnum {
  PREFIX = 'CognitoIdentityServiceProvider',

  LAST_AUTH_USER = 'LastAuthUser',
  ACCESS_TOKEN = 'accessToken',
  ID_TOKEN = 'idToken',
  REFRESH_TOKEN = 'refreshToken',
}
